module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/other-2-83e7711f2778bc167ed40e72d7542c63.svg";